"use client";

import { GTMEvent } from ".constants/gtmEvents";
import { cn, OfferNoTimer, Offer as UIOffer } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC, memo } from "react";

import { useClickOffer } from "./useClickOffer";

type OfferProps = {
  gtmEvent?: string | null;
  description: string;
  endsAt: Date;
  href?: string | null;
  position: number;
  timerColor?: string | null;
  title: string;
  type: OfferType | number;
  url: string | null;
  textColor?: string | null;
};

enum OfferType {
  WITH_TIMER = 0,
  NO_TIMER = 1,
}

enum TextColor {
  BLACK = "black",
  WHITE = "white",
}

type TimerColorType = "orange" | "white" | "pink" | undefined;

export const Offer: FC<OfferProps> = memo(
  ({
    type,
    href,
    url,
    endsAt,
    title,
    description,
    timerColor,
    gtmEvent,
    textColor,
  }: OfferProps) => {
    const n = useTranslations("TimerForOffer");
    const handleClickOffer = useClickOffer();

    const isBannerWithTimer = type === OfferType.WITH_TIMER && endsAt;

    const textColorCn = () => {
      if (textColor === TextColor.BLACK) {
        return "text-black";
      }

      if (textColor === TextColor.WHITE) {
        return "text-white";
      }

      return "text-black";
    };

    return isBannerWithTimer ? (
      <UIOffer
        image={url || ""}
        theme="covered"
        title={<span className={textColorCn()}>{title}</span>}
        days={n("days")}
        hours={n("hours")}
        minutes={n("minutes")}
        seconds={n("seconds")}
        endDate={endsAt}
        href={href || undefined}
        onClick={gtmEvent ? handleClickOffer(gtmEvent as GTMEvent) : undefined}
        timerColor={(timerColor || undefined) as TimerColorType}
      />
    ) : (
      <OfferNoTimer
        image={url || ""}
        theme="covered"
        title={<span className={textColorCn()}>{title}</span>}
        text={
          <span className={cn("text-sm/4 font-medium", textColorCn())}>
            {description}
          </span>
        }
        href={href || undefined}
        onClick={gtmEvent ? handleClickOffer(gtmEvent as GTMEvent) : undefined}
      />
    );
  },
);
Offer.displayName = "Offer";
